"use client";

import { Container, Box } from "@mui/material";
import { GalleryItemPayloadV2 } from "@/types/gallery";
import { useEffect, useState } from "react";
import { trackEngagement } from "@/app/utils/engagement";
import { notFound } from "next/navigation";
import MemoItem from "@/app/components/MemeItem";
import TrendingGrid from "@/app/components/TrendingGrid";
import LoadingBox from "@/app/components/LoadingBox";
import { trackEvent } from "@/app/utils/analytics";
import { fetchWithAuth } from "@/lib/firebase/authInterceptor";
interface MemePageClientProps {
  id: string;
}

export default function MemePageClient({ id }: MemePageClientProps) {
  const [meme, setMeme] = useState<GalleryItemPayloadV2 | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const renderTabContent = () => {
    return <TrendingGrid />;
  };

  useEffect(() => {
    // Track deep link engagement when the page loads
    trackEngagement(id, "deep_link");
    trackEvent("meme_deep_link_visit", {});

    // Fetch meme data
    async function fetchMeme() {
      try {
        const response = await fetchWithAuth(`/api/v2/meme/${id}`, {
          method: "GET"
        });

        if (!response.ok) {
          if (response.status === 404) {
            setMeme(null);
            return;
          }
          throw new Error(`Failed to fetch meme: ${response.statusText}`);
        }

        const data = await response.json();
        const itemPayloadV2 = data as GalleryItemPayloadV2;
        setMeme(itemPayloadV2);
      } catch (error) {
        console.error("Error fetching meme:", error);
        setMeme(null);
      } finally {
        setIsLoading(false);
      }
    }
    fetchMeme();
  }, [id]);

  if (isLoading) return <LoadingBox />;

  if (!meme) {
    notFound();
  }

  return (
    <Container maxWidth="lg">
      <MemoItem memo={meme} withScore={false} />
      <Box
        className="main-page-box"
        component="div"
        sx={{
          minHeight: "calc(100vh - 64px)",
          pt: 1,
          bgcolor: "background.default"
        }}
      >
        {renderTabContent()}
      </Box>
    </Container>
  );
}
